 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		98: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"2":"component---gatsby-theme-code-recipes-src-query-js","3":"component---gatsby-theme-style-guide-src-template-js","4":"component---src-pages-404-mdx","5":"component---src-pages-api-mdx","6":"component---src-pages-color-modes-mdx","7":"component---src-pages-components-alert-mdx","8":"component---src-pages-components-aspect-image-mdx","9":"component---src-pages-components-aspect-ratio-mdx","10":"component---src-pages-components-avatar-mdx","11":"component---src-pages-components-badge-mdx","12":"component---src-pages-components-box-mdx","13":"component---src-pages-components-button-mdx","14":"component---src-pages-components-card-mdx","15":"component---src-pages-components-checkbox-mdx","16":"component---src-pages-components-close-mdx","17":"component---src-pages-components-container-mdx","18":"component---src-pages-components-divider-mdx","19":"component---src-pages-components-donut-mdx","20":"component---src-pages-components-embed-mdx","21":"component---src-pages-components-field-mdx","22":"component---src-pages-components-flex-mdx","23":"component---src-pages-components-forms-mdx","24":"component---src-pages-components-grid-mdx","25":"component---src-pages-components-heading-mdx","26":"component---src-pages-components-icon-button-mdx","27":"component---src-pages-components-image-mdx","28":"component---src-pages-components-index-mdx","29":"component---src-pages-components-input-mdx","30":"component---src-pages-components-label-mdx","31":"component---src-pages-components-link-mdx","32":"component---src-pages-components-menu-button-mdx","33":"component---src-pages-components-message-mdx","34":"component---src-pages-components-nav-link-mdx","35":"component---src-pages-components-progress-mdx","36":"component---src-pages-components-radio-mdx","37":"component---src-pages-components-select-mdx","38":"component---src-pages-components-slider-mdx","39":"component---src-pages-components-spinner-mdx","40":"component---src-pages-components-text-mdx","41":"component---src-pages-components-textarea-mdx","42":"component---src-pages-components-variants-mdx","43":"component---src-pages-customize-js","44":"component---src-pages-demo-mdx","45":"component---src-pages-getting-started-gatsby-mdx","46":"component---src-pages-getting-started-index-mdx","47":"component---src-pages-guides-color-mode-toggles-mdx","48":"component---src-pages-guides-global-styles-mdx","49":"component---src-pages-guides-how-it-works-mdx","50":"component---src-pages-guides-index-mdx","51":"component---src-pages-guides-jsx-pragma-mdx","52":"component---src-pages-guides-layouts-mdx","53":"component---src-pages-guides-linked-headings-mdx","54":"component---src-pages-guides-mdx-layout-components-mdx","55":"component---src-pages-guides-merging-themes-mdx","56":"component---src-pages-guides-motivation-mdx","57":"component---src-pages-guides-nested-theme-providers-mdx","58":"component---src-pages-guides-object-styles-mdx","59":"component---src-pages-guides-responsive-typography-mdx","60":"component---src-pages-guides-styled-components-mdx","61":"component---src-pages-guides-syntax-highlighting-mdx","62":"component---src-pages-guides-theme-color-meta-tag-mdx","63":"component---src-pages-guides-using-theme-ui-without-mdx-mdx","64":"component---src-pages-guides-variants-mdx","65":"component---src-pages-hooks-mdx","66":"component---src-pages-index-mdx","67":"component---src-pages-layout-mdx","68":"component---src-pages-mdx-components-mdx","69":"component---src-pages-migrating-mdx","70":"component---src-pages-packages-color-mdx","71":"component---src-pages-packages-editor-mdx","72":"component---src-pages-packages-gatsby-plugin-mdx","73":"component---src-pages-packages-gatsby-theme-style-guide-mdx","74":"component---src-pages-packages-gatsby-theme-ui-blog-mdx","75":"component---src-pages-packages-index-mdx","76":"component---src-pages-packages-match-media-mdx","77":"component---src-pages-packages-presets-mdx","78":"component---src-pages-packages-prism-mdx","79":"component---src-pages-packages-sidenav-mdx","80":"component---src-pages-packages-style-guide-mdx","81":"component---src-pages-packages-tachyons-mdx","82":"component---src-pages-packages-tailwind-mdx","83":"component---src-pages-packages-typography-mdx","84":"component---src-pages-random-js","85":"component---src-pages-readme-mdx","86":"component---src-pages-recipes-demo-js","87":"component---src-pages-recipes-index-js","88":"component---src-pages-recipes-notes-mdx","89":"component---src-pages-static-css-mdx","90":"component---src-pages-styled-mdx","91":"component---src-pages-styling-mdx-mdx","92":"component---src-pages-sx-prop-mdx","93":"component---src-pages-testimonials-mdx","94":"component---src-pages-theme-spec-mdx","95":"component---src-pages-theming-mdx","96":"component---src-pages-use-theme-ui-mdx","97":"component---src-templates-preset-js"}[chunkId]||chunkId) + "-" + {"2":"8feb60ef18bd58611e22","3":"4789a05407cb8340f837","4":"4b71c91d834396972eb5","5":"f1dd2a7306b51ff30a3b","6":"4e29d2bbb86cae2f2bb9","7":"ace07ad7b9a5bf87bbea","8":"5f6fb9780f0d5e9b140f","9":"4da1bfb9ef0ff938ce4d","10":"d41914c09e799e8c6ef3","11":"8ab96881ec50ce0bd66f","12":"6d1b6fdd231aafdcc104","13":"c86f7c053cebbef3a191","14":"b6a3a44fb87e8bdf165b","15":"7a234f68d6ab4c6c4afe","16":"cbf2eb0087d40c8182e2","17":"4a338acec5ca29ff1cfd","18":"7e846cf5e84ffed0110a","19":"fd6b42797fd58720231d","20":"fcc5d25e7c810eac055c","21":"863dac3b5da5707ab463","22":"0edf33cb0db0db668ae5","23":"f6dd17b1edf5da1c834b","24":"c95155c346c80c03266f","25":"e966362be7e52b06299c","26":"2ced13cdec1f741672e0","27":"f1b000e762a7a7e0e097","28":"0cd6861afcc40db4e96c","29":"7e7f5492a1d0010aba45","30":"d012bcebe88a70179f6f","31":"57cac4478535b885f280","32":"c14f930fd900f91b55e3","33":"e1ea505267e12459c513","34":"a1226d921a69da0bfca4","35":"09a7f704a6a12fdfc0bd","36":"def58b4c3029a1bda366","37":"14bf9ad137104e2dd9f3","38":"848af72ff905af91de5c","39":"21684f063db36bc03395","40":"b6a6292c0e8393b17719","41":"72d744c2933669d510a5","42":"61d21fd3caa0ea2efe6d","43":"570cc2aedb783cf4eb20","44":"e84564adfeee5e402711","45":"eef336ca5357e1b4db1b","46":"698628957af23e4598a3","47":"e8b0cd64d770e7f8757e","48":"4ddaaa462206ffc010f7","49":"4099c254a35e808eb9fe","50":"285ee8d84f7b2d273d5c","51":"2c83b7de2914117fc448","52":"da2bf4b269050ae7aa82","53":"5ff7ca8b63b2112765f9","54":"d7be17bdbfb5ca145551","55":"ae43e2b0e653031505ad","56":"7f5b6bb94aae235feb3b","57":"f867fa134d27c5b449f1","58":"a9c0a70e4a339fd35c25","59":"807bd837cfaa58b399fb","60":"3cd8dc10edaa6667b172","61":"0bdb6d48d4c312d56770","62":"330dd4aa85d7d650a05c","63":"e80eab83139507b4f85d","64":"554fa39f4cbe6078bfef","65":"8e570d8b1db8f3f1e54e","66":"2819bab5ef59d6524b85","67":"e53e15ce265484632d98","68":"ba2b84c34147018331fb","69":"58bbdef983753aa2b1f8","70":"72c4ba05d237edbd45c7","71":"33f324f61476071dde7b","72":"9cd4c5f4da33949a99f9","73":"70bda8e5ff72057125b4","74":"14446ac7ee0b35644d61","75":"a15b58f0e218dc8d3536","76":"49c2e418e890fe860c07","77":"0274cb368f83b6378797","78":"602e349d46c9002a06e9","79":"cfc013eafea450b70262","80":"ca03edce7f988bf713fc","81":"f7cba742ea7d91770547","82":"16b6013283fdaf837cd4","83":"4aa0b860e81f6776853d","84":"67c705836014d97aedbb","85":"04f3005641a4705a97ce","86":"3dfc696b8edd8ff9ca0c","87":"5bd691e7e097c8ab26bc","88":"bef1eabe3348071018e3","89":"3f379d732d1a64ad53fa","90":"8b04c511cee1d1a27b36","91":"6dce16750c39599ce95f","92":"409397936c00ac3ebdc9","93":"906106fb7cc55ee0f9dc","94":"ee9c3ee29d961e4215b6","95":"89bca04334676df3a5df","96":"8ae4cc9548b54adaa91c","97":"ff87c1fc3d7a03c136be"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
